import { useQuery } from "@tanstack/react-query"
import { ProductionKeyValuePairGet } from "../app/models/ProductionKeyValuePair"
import { digitalManagerApi } from "../services/api"

export function useProductionKeyValuePairs() {
  const { data: keyValuePairsList = [], isLoading: isLoadingKeyValuePairs } = useQuery({
    queryKey: ["productionKeyValuePairs"],
    queryFn: () =>
      digitalManagerApi
        .get<ProductionKeyValuePairGet[]>("/production/keyValuePairs")
        .then((r) => r.data),
  })

  return {
    keyValuePairsList,
    isLoadingKeyValuePairs,
  }
}
